import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, CreditCardIcon, ChevronDownIcon, StarIcon, AlertTriangleIcon, BookOpenIcon, UsersIcon, TrendingUpIcon, GlobeIcon, FileTextIcon, LockIcon, ZapIcon, BriefcaseIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { PricingGrid } from './PricingGrid';
const IMAGES = {
  MAIN: 'https://cdn.magicpatterns.com/uploads/ikXdfRfv4e88eZk6fueqcq/conjunto_de_OBSERVATORIO_DE_MEDIOS.png'
};
const LINKS = {
  PACK_COMPLETO: 'https://pagos.docentesfelices.online/cart/50995509690674:1',
  PACK_COMPLETO_GESTION: 'https://pagos.docentesfelices.online/cart/50995511394610:1'
};
export function SalesPage() {
  const [openCuadernillo, setOpenCuadernillo] = useState<number | null>(null);
  const [selectedPack, setSelectedPack] = useState(0);
  const packLinks = [LINKS.PACK_COMPLETO, LINKS.PACK_COMPLETO_GESTION];
  const [urgencyTime, setUrgencyTime] = useState({
    hours: 2,
    minutes: 13,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setUrgencyTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-gray-300 bg-[#0c1a3a] min-h-screen flex flex-col" data-id="element-41">
      <CountdownTimer data-id="element-42" />
      <SocialProofPopup data-id="element-43" />

      {/* HERO */}
      <section className="py-2 md:py-6 px-3 md:px-4 text-center" style={{
      background: 'linear-gradient(180deg, #0c1a3a 0%, #1a1040 50%, #0d1b3a 100%)'
    }} data-id="element-44">
        <div className="max-w-3xl mx-auto" data-id="element-45">
          <p className="text-[#eab308] text-[10px] md:text-xs font-black uppercase tracking-widest mb-1 md:mb-2 drop-shadow-[0_0_8px_rgba(234,179,8,0.5)]" data-id="element-46">
            ⭐ El recurso #1 para docentes de Observatorio de Medios ⭐
          </p>

          <h1 className="text-xl md:text-3xl lg:text-4xl font-black text-white mb-1 md:mb-2 leading-tight uppercase drop-shadow-md" data-id="element-47">
            Dejá de perder horas preparando clases sobre medios, redes y
            noticias
          </h1>

          <div onClick={scrollToPricing} className="cursor-pointer hover:opacity-95 transition-opacity my-1 md:my-3" data-id="element-48">
            <img src={IMAGES.MAIN} alt="Pack Completo Observatorio de Medios y Redes Mockup" className="w-full max-w-md mx-auto drop-shadow-[0_0_40px_rgba(234,179,8,0.3)]" data-id="element-49" />
          </div>

          <p className="text-sm md:text-lg text-[#eab308] font-black italic mb-1 md:mb-2 uppercase drop-shadow-[0_0_8px_rgba(234,179,8,0.3)]" data-id="element-50">
            Listo para usar. Sin buscar más.
          </p>

          <p className="text-xs md:text-sm text-gray-300 mb-2 md:mb-4 max-w-xl mx-auto font-medium" data-id="element-51">
            El sistema que usan los docentes en Argentina para planificar todo
            el año en una tarde
          </p>

          <div className="flex justify-center gap-1 md:gap-2 mb-2 md:mb-3 flex-nowrap" data-id="element-52">
            <span className="flex items-center gap-0.5 border border-[#eab308]/40 bg-[#0f1a35]/80 backdrop-blur-sm shadow-[0_0_10px_rgba(234,179,8,0.1)] text-gray-300 text-[9px] md:text-[10px] px-1.5 py-0.5 md:px-2 md:py-1 rounded-full whitespace-nowrap font-bold" data-id="element-53">
              <FileTextIcon className="w-2 h-2 md:w-2.5 md:h-2.5 text-[#eab308]" data-id="element-54" />{' '}
              100% PDF
            </span>
            <span className="flex items-center gap-0.5 border border-[#eab308]/40 bg-[#0f1a35]/80 backdrop-blur-sm shadow-[0_0_10px_rgba(234,179,8,0.1)] text-gray-300 text-[9px] md:text-[10px] px-1.5 py-0.5 md:px-2 md:py-1 rounded-full whitespace-nowrap font-bold" data-id="element-55">
              <ZapIcon className="w-2 h-2 md:w-2.5 md:h-2.5 text-[#eab308]" data-id="element-56" />{' '}
              Acceso inmediato
            </span>
            <span className="flex items-center gap-0.5 border border-[#eab308]/40 bg-[#0f1a35]/80 backdrop-blur-sm shadow-[0_0_10px_rgba(234,179,8,0.1)] text-gray-300 text-[9px] md:text-[10px] px-1.5 py-0.5 md:px-2 md:py-1 rounded-full whitespace-nowrap font-bold" data-id="element-57">
              🇦🇷 Currículo argentino
            </span>
          </div>

          <button onClick={scrollToPricing} className="cta-pulse inline-flex items-center justify-center bg-[#eab308] hover:bg-[#ca8a04] text-black font-black text-xs md:text-base py-2 px-4 md:py-3 md:px-8 rounded-lg transition-all duration-200 mb-1.5 md:mb-3 whitespace-nowrap uppercase" data-id="element-58">
            → QUIERO MI PACK COMPLETO AHORA
          </button>

          <div className="flex justify-center gap-1.5 md:gap-3 text-[9px] md:text-[10px] text-gray-300 font-bold flex-nowrap uppercase tracking-wider" data-id="element-59">
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-60">
              <ShieldCheckIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-[#eab308]" data-id="element-61" />{' '}
              Garantía 7 días
            </span>
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-62">
              <LockIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-[#eab308]" data-id="element-63" />{' '}
              Pago seguro
            </span>
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-64">
              <CreditCardIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-[#eab308]" data-id="element-65" />{' '}
              Mercado Pago
            </span>
          </div>
        </div>
      </section>

      {/* PAIN POINTS */}
      <section className="py-3 md:py-6 px-4 border-t-2 border-[#eab308]/20" style={{
      background: 'linear-gradient(180deg, #0f1f3d 0%, #162040 100%)'
    }} data-id="element-66">
        <div className="max-w-2xl mx-auto" data-id="element-67">
          <h2 className="text-xl md:text-2xl font-black text-center text-red-500 mb-3 md:mb-4 uppercase drop-shadow-[0_0_10px_rgba(239,68,68,0.3)]" data-id="element-68">
            <span className="underline decoration-red-500/50 decoration-4 underline-offset-2" data-id="element-69">
              ❌ ¿Te pasa esto?
            </span>
          </h2>

          <div className="space-y-1.5 md:space-y-2 text-sm md:text-base text-gray-200 font-medium leading-snug bg-[#0f1a35]/60 backdrop-blur-sm p-4 md:p-6 rounded-xl border border-[#eab308]/20 shadow-[0_0_15px_rgba(0,0,0,0.3)]" data-id="element-70">
            <p className="flex items-start gap-1.5" data-id="element-71">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-72">
                ❌
              </span>
              Buscás material sobre medios y redes y encontrás contenidos
              genéricos que no se adaptan a la realidad actual
            </p>
            <p className="flex items-start gap-1.5" data-id="element-73">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-74">
                ❌
              </span>
              Armás actividades desde cero porque no existe material organizado
              para secundaria
            </p>
            <p className="flex items-start gap-1.5" data-id="element-75">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-76">
                ❌
              </span>
              Tus alumnos están en redes todo el día… pero no sabés cómo llevar
              eso al aula
            </p>
            <p className="flex items-start gap-1.5" data-id="element-77">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-78">
                ❌
              </span>
              Las planificaciones y evaluaciones te consumen horas que no tenés
            </p>
            <p className="flex items-start gap-1.5" data-id="element-79">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-80">
                ❌
              </span>
              Querés trabajar análisis de noticias, redes sociales y pensamiento
              crítico… pero no tenés el material estructurado
            </p>
          </div>
        </div>
      </section>

      {/* EXTRA PERSUASIVE CTA */}
      <section className="py-2 md:py-4 px-4 text-center" style={{
      background: 'linear-gradient(180deg, #162040 0%, #1a1040 100%)'
    }} data-id="element-81">
        <div className="flex flex-col items-center gap-3" data-id="element-82">
          <button onClick={scrollToPricing} className="cta-pulse bg-[#eab308] hover:bg-[#ca8a04] text-black font-black text-sm md:text-lg py-2.5 px-4 md:py-3 md:px-6 rounded-lg transition-all duration-200 w-full md:w-auto max-w-xl uppercase" data-id="element-83">
            🔥 ¡QUIERO DEJAR DE IMPROVISAR Y TENER TODO RESUELTO!
          </button>

          <button onClick={scrollToPricing} className="cta-pulse-red border-2 border-red-500 bg-red-500/10 hover:bg-red-500/20 text-red-400 font-black text-xs md:text-sm py-2 px-4 md:py-2.5 md:px-6 rounded-lg transition-all duration-200 w-full md:w-auto max-w-xl uppercase backdrop-blur-sm" data-id="element-84">
            🚀 ¡ACCEDÉ AL PACK AHORA CON 50% OFF!
          </button>
        </div>
      </section>

      {/* SOLUTION */}
      <section className="py-4 md:py-6 px-4 text-center" style={{
      background: 'linear-gradient(180deg, #1a1040 0%, #0f1f3d 100%)'
    }} data-id="element-85">
        <div className="max-w-3xl mx-auto" data-id="element-86">
          <span className="inline-block bg-[#eab308] text-black text-[10px] font-black px-2 py-0.5 rounded-full mb-1.5 md:mb-3 uppercase tracking-widest shadow-[0_0_10px_rgba(234,179,8,0.4)]" data-id="element-87">
            La Solución
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-white mb-1.5 md:mb-3 uppercase drop-shadow-md" data-id="element-88">
            PACK COMPLETO{' '}
            <span className="text-white underline decoration-[#eab308] decoration-4 underline-offset-4 drop-shadow-[0_0_10px_rgba(234,179,8,0.3)]" data-id="element-89">
              OBSERVATORIO DE MEDIOS Y REDES
            </span>
          </h2>
          <p className="text-sm md:text-base text-gray-300 mb-3 md:mb-5 max-w-2xl mx-auto font-medium" data-id="element-90">
            Sistema integral de clases, actividades, proyectos y evaluaciones
            diseñadas específicamente para secundaria.
          </p>

          <div className="flex flex-col items-center gap-1.5 md:gap-2 text-sm md:text-base font-bold text-white text-left max-w-xl mx-auto bg-[#0f1a35]/60 backdrop-blur-sm p-4 md:p-6 rounded-xl border border-[#eab308]/30 shadow-[0_0_20px_rgba(234,179,8,0.15)]" data-id="element-91">
            <span className="flex items-start gap-2 w-full" data-id="element-92">
              <span className="flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-93">
                ✅
              </span>
              Dar clases sobre medios y redes con material claro, actual y listo
              para usar
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-94">
              <span className="flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-95">
                ✅
              </span>
              Tener actividades, trabajos prácticos y evaluaciones sin preparar
              nada adicional
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-96">
              <span className="flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-97">
                ✅
              </span>
              Cumplir con los NAP 2026 y justificar ante directivos con rúbricas
              por capacidades
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-98">
              <span className="flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-99">
                ✅
              </span>
              Conectar con tus alumnos usando contenido real: redes sociales,
              noticias y cultura digital
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-100">
              <span className="flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-101">
                ✅
              </span>
              Ahorrar horas de trabajo cada semana
            </span>
          </div>
        </div>
      </section>

      {/* CONTENTS ACCORDION */}
      <section className="py-4 md:py-6 px-4" style={{
      background: 'linear-gradient(180deg, #0d1b3a 0%, #0c2340 100%)'
    }} data-id="element-102">
        <div className="max-w-3xl mx-auto" data-id="element-103">
          <div className="text-center mb-3 md:mb-5" data-id="element-104">
            <h2 className="text-xl md:text-3xl font-black text-white mb-1 md:mb-2 uppercase drop-shadow-md" data-id="element-105">
              ¿QUÉ INCLUYE EL{' '}
              <span className="underline decoration-[#eab308] decoration-4 underline-offset-2 drop-shadow-[0_0_10px_rgba(234,179,8,0.3)]" data-id="element-106">
                PACK COMPLETO
              </span>
              ?
            </h2>
            <p className="text-sm md:text-base text-[#eab308] font-black mb-1 uppercase drop-shadow-[0_0_5px_rgba(234,179,8,0.2)]" data-id="element-107">
              📚 360 páginas · 6 tomos · Alineado NAP 2026
            </p>
            <p className="text-[10px] md:text-xs text-gray-300 font-bold uppercase tracking-wider" data-id="element-108">
              ✅ Tocá cada cuadernillo para ver su contenido
            </p>
          </div>

          <div className="space-y-1.5 md:space-y-2" data-id="element-109">
            {/* Tomo 1 */}
            <div className="bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#eab308]/40 overflow-hidden transition-all hover:border-[#eab308]/70 shadow-[0_0_12px_rgba(234,179,8,0.15)] hover:shadow-[0_0_20px_rgba(234,179,8,0.25)]" data-id="element-110">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 0 ? null : 0)} className="w-full flex items-center gap-2 p-2.5 md:p-3.5 text-left cursor-pointer" data-id="element-111">
                <BookOpenIcon className="w-5 h-5 md:w-6 md:h-6 text-blue-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(96,165,250,0.5)]" data-id="element-112" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-113">
                  TOMO 1 — Introducción a los Medios y la Comunicación
                </h3>
                <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-[#eab308] flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 0 ? 'rotate-180' : ''}`} data-id="element-114" />
              </button>
              <AnimatePresence data-id="element-115">
                {openCuadernillo === 0 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-[#0a1128]/50" data-id="element-116">
                    <div className="px-3 md:px-4 pb-2.5 md:pb-3.5 border-t border-[#eab308]/20 pt-2.5 md:pt-3" data-id="element-117">
                      <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug" data-id="element-118">
                        Qué son los medios y cómo influyen. Tipos de medios
                        (tradicionales y digitales). Cómo consumen información
                        los jóvenes. Rol social de los medios. Incluye:
                        diagnóstico de consumo mediático, actividades
                        introductorias, debates guiados, análisis de casos
                        actuales.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 2 */}
            <div className="bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#eab308]/40 overflow-hidden transition-all hover:border-[#eab308]/70 shadow-[0_0_12px_rgba(234,179,8,0.15)] hover:shadow-[0_0_20px_rgba(234,179,8,0.25)]" data-id="element-119">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 1 ? null : 1)} className="w-full flex items-center gap-2 p-2.5 md:p-3.5 text-left cursor-pointer" data-id="element-120">
                <TrendingUpIcon className="w-5 h-5 md:w-6 md:h-6 text-green-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(74,222,128,0.5)]" data-id="element-121" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-122">
                  TOMO 2 — Análisis de Noticias
                </h3>
                <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-[#eab308] flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 1 ? 'rotate-180' : ''}`} data-id="element-123" />
              </button>
              <AnimatePresence data-id="element-124">
                {openCuadernillo === 1 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-[#0a1128]/50" data-id="element-125">
                    <div className="px-3 md:px-4 pb-2.5 md:pb-3.5 border-t border-[#eab308]/20 pt-2.5 md:pt-3" data-id="element-126">
                      <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug" data-id="element-127">
                        Cómo se construye una noticia. Agenda mediática. Sesgos
                        informativos. Manipulación de información. Incluye:
                        comparación de medios, análisis de titulares,
                        interpretación de noticias, actividades prácticas.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 3 */}
            <div className="bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#eab308]/40 overflow-hidden transition-all hover:border-[#eab308]/70 shadow-[0_0_12px_rgba(234,179,8,0.15)] hover:shadow-[0_0_20px_rgba(234,179,8,0.25)]" data-id="element-128">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 2 ? null : 2)} className="w-full flex items-center gap-2 p-2.5 md:p-3.5 text-left cursor-pointer" data-id="element-129">
                <UsersIcon className="w-5 h-5 md:w-6 md:h-6 text-amber-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(251,191,36,0.5)]" data-id="element-130" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-131">
                  TOMO 3 — Redes Sociales y Cultura Digital
                </h3>
                <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-[#eab308] flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 2 ? 'rotate-180' : ''}`} data-id="element-132" />
              </button>
              <AnimatePresence data-id="element-133">
                {openCuadernillo === 2 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-[#0a1128]/50" data-id="element-134">
                    <div className="px-3 md:px-4 pb-2.5 md:pb-3.5 border-t border-[#eab308]/20 pt-2.5 md:pt-3" data-id="element-135">
                      <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug" data-id="element-136">
                        Funcionamiento de redes sociales. Algoritmos y
                        viralización. Influencers y contenido digital. Economía
                        de la atención. Incluye: análisis de Instagram y TikTok,
                        actividades con redes, creación de contenido, debates
                        actuales.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 4 */}
            <div className="bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#eab308]/40 overflow-hidden transition-all hover:border-[#eab308]/70 shadow-[0_0_12px_rgba(234,179,8,0.15)] hover:shadow-[0_0_20px_rgba(234,179,8,0.25)]" data-id="element-137">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 3 ? null : 3)} className="w-full flex items-center gap-2 p-2.5 md:p-3.5 text-left cursor-pointer" data-id="element-138">
                <GlobeIcon className="w-5 h-5 md:w-6 md:h-6 text-red-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(248,113,113,0.5)]" data-id="element-139" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-140">
                  TOMO 4 — Información, Veracidad y Pensamiento Crítico
                </h3>
                <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-[#eab308] flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 3 ? 'rotate-180' : ''}`} data-id="element-141" />
              </button>
              <AnimatePresence data-id="element-142">
                {openCuadernillo === 3 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-[#0a1128]/50" data-id="element-143">
                    <div className="px-3 md:px-4 pb-2.5 md:pb-3.5 border-t border-[#eab308]/20 pt-2.5 md:pt-3" data-id="element-144">
                      <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug" data-id="element-145">
                        Cómo evaluar la información. Diferencia entre
                        información y opinión. Construcción de sentido. Lectura
                        crítica de medios. Incluye: análisis de casos reales,
                        actividades de verificación, ejercicios de
                        interpretación, debates guiados.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 5 */}
            <div className="bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#eab308]/40 overflow-hidden transition-all hover:border-[#eab308]/70 shadow-[0_0_12px_rgba(234,179,8,0.15)] hover:shadow-[0_0_20px_rgba(234,179,8,0.25)]" data-id="element-146">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 4 ? null : 4)} className="w-full flex items-center gap-2 p-2.5 md:p-3.5 text-left cursor-pointer" data-id="element-147">
                <BriefcaseIcon className="w-5 h-5 md:w-6 md:h-6 text-yellow-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(250,204,21,0.5)]" data-id="element-148" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-149">
                  TOMO 5 — Producción de Contenido
                </h3>
                <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-[#eab308] flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 4 ? 'rotate-180' : ''}`} data-id="element-150" />
              </button>
              <AnimatePresence data-id="element-151">
                {openCuadernillo === 4 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-[#0a1128]/50" data-id="element-152">
                    <div className="px-3 md:px-4 pb-2.5 md:pb-3.5 border-t border-[#eab308]/20 pt-2.5 md:pt-3" data-id="element-153">
                      <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug" data-id="element-154">
                        Cómo comunicar en medios digitales. Narrativa digital.
                        Producción de contenido educativo. Comunicación
                        responsable. Incluye: creación de proyectos, producción
                        de contenido, trabajos grupales, actividades aplicadas.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 6 */}
            <div className="bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#eab308]/40 overflow-hidden transition-all hover:border-[#eab308]/70 shadow-[0_0_12px_rgba(234,179,8,0.15)] hover:shadow-[0_0_20px_rgba(234,179,8,0.25)]" data-id="element-155">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 5 ? null : 5)} className="w-full flex items-center gap-2 p-2.5 md:p-3.5 text-left cursor-pointer" data-id="element-156">
                <FileTextIcon className="w-5 h-5 md:w-6 md:h-6 text-purple-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(192,132,252,0.5)]" data-id="element-157" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-158">
                  TOMO 6 — Proyecto Integrador: Observatorio de Medios
                </h3>
                <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-[#eab308] flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 5 ? 'rotate-180' : ''}`} data-id="element-159" />
              </button>
              <AnimatePresence data-id="element-160">
                {openCuadernillo === 5 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-[#0a1128]/50" data-id="element-161">
                    <div className="px-3 md:px-4 pb-2.5 md:pb-3.5 border-t border-[#eab308]/20 pt-2.5 md:pt-3" data-id="element-162">
                      <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug" data-id="element-163">
                        Análisis completo de medios y redes. Investigación de
                        consumo digital. Presentación de proyectos. Evaluación
                        final. Incluye: guía paso a paso, rúbricas completas,
                        proyectos aplicados, presentación final.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-4 md:py-6 px-4" style={{
      background: 'linear-gradient(180deg, #0c2340 0%, #1a1040 100%)'
    }} data-id="element-164">
        <div className="max-w-4xl mx-auto" data-id="element-165">
          <div className="text-center mb-3 md:mb-5" data-id="element-166">
            <h2 className="text-xl md:text-3xl font-black text-white mb-1.5 md:mb-2 uppercase leading-tight drop-shadow-md" data-id="element-167">
              <span className="text-[#eab308] drop-shadow-[0_0_10px_rgba(234,179,8,0.4)]" data-id="element-168">
                BONUS
              </span>{' '}
              exclusivos incluidos
            </h2>

            <div className="inline-flex items-center gap-1.5 bg-red-600 text-white font-black text-[10px] md:text-xs px-3 md:px-5 py-1 md:py-1.5 rounded-lg shadow-[0_0_20px_rgba(220,38,38,0.6)] border border-red-400 mb-3 md:mb-4 uppercase tracking-widest" data-id="element-169">
              <span className="text-sm md:text-base" data-id="element-170">🎁</span>
              ¡GRATIS POR EL DÍA DE HOY!
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-3 mb-3 md:mb-5" data-id="element-171">
            {/* Bonus 1 */}
            <div className="relative bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#f59e0b]/50 overflow-hidden p-2.5 md:p-4 flex flex-col shadow-[0_0_15px_rgba(245,158,11,0.2)] hover:shadow-[0_0_25px_rgba(245,158,11,0.3)] transition-all" data-id="element-172">
              <span className="absolute top-1 right-2 text-[30px] md:text-[50px] font-black text-white/[0.06] leading-none select-none pointer-events-none" data-id="element-173">
                01
              </span>
              <span className="inline-block bg-red-600 text-white text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest mb-1.5 self-start shadow-[0_0_8px_rgba(220,38,38,0.5)]" data-id="element-174">
                BONO #01
              </span>
              <div className="text-2xl md:text-3xl mb-1.5 drop-shadow-md" data-id="element-175">
                📋
              </div>
              <h3 className="text-xs md:text-sm font-black text-white mb-1 uppercase" data-id="element-176">
                Planificación Anual de Observatorio de Medios
              </h3>
              <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug flex-1" data-id="element-177">
                Planificación completa del año. Organización por unidades.
                Objetivos claros. Secuencia didáctica lista.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t border-[#f59e0b]/30" data-id="element-178">
                <span className="text-gray-400 text-[9px] md:text-[10px] line-through font-bold" data-id="element-179">
                  Valor $8.500
                </span>
                <span className="bg-[#eab308] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest shadow-[0_0_8px_rgba(234,179,8,0.5)]" data-id="element-180">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="relative bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#f59e0b]/50 overflow-hidden p-2.5 md:p-4 flex flex-col shadow-[0_0_15px_rgba(245,158,11,0.2)] hover:shadow-[0_0_25px_rgba(245,158,11,0.3)] transition-all" data-id="element-181">
              <span className="absolute top-1 right-2 text-[30px] md:text-[50px] font-black text-white/[0.06] leading-none select-none pointer-events-none" data-id="element-182">
                02
              </span>
              <span className="inline-block bg-[#eab308] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest mb-1.5 self-start shadow-[0_0_8px_rgba(234,179,8,0.5)]" data-id="element-183">
                BONO #02
              </span>
              <div className="text-2xl md:text-3xl mb-1.5 drop-shadow-md" data-id="element-184">
                📚
              </div>
              <h3 className="text-xs md:text-sm font-black text-white mb-1 uppercase" data-id="element-185">
                100 Actividades sobre Medios y Redes
              </h3>
              <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug flex-1" data-id="element-186">
                Actividades con redes sociales. Análisis de noticias. Debates
                actuales. Dinámicas grupales.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t border-[#f59e0b]/30" data-id="element-187">
                <span className="text-gray-400 text-[9px] md:text-[10px] line-through font-bold" data-id="element-188">
                  Valor $8.500
                </span>
                <span className="bg-[#eab308] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest shadow-[0_0_8px_rgba(234,179,8,0.5)]" data-id="element-189">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="relative bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#f59e0b]/50 overflow-hidden p-2.5 md:p-4 flex flex-col shadow-[0_0_15px_rgba(245,158,11,0.2)] hover:shadow-[0_0_25px_rgba(245,158,11,0.3)] transition-all" data-id="element-190">
              <span className="absolute top-1 right-2 text-[30px] md:text-[50px] font-black text-white/[0.06] leading-none select-none pointer-events-none" data-id="element-191">
                03
              </span>
              <span className="inline-block bg-red-600 text-white text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest mb-1.5 self-start shadow-[0_0_8px_rgba(220,38,38,0.5)]" data-id="element-192">
                BONO #03
              </span>
              <div className="text-2xl md:text-3xl mb-1.5 drop-shadow-md" data-id="element-193">
                📊
              </div>
              <h3 className="text-xs md:text-sm font-black text-white mb-1 uppercase" data-id="element-194">
                Sistema PRO de Evaluación en Medios
              </h3>
              <p className="text-gray-300 text-[10px] md:text-xs font-medium leading-snug flex-1" data-id="element-195">
                Evaluaciones diagnósticas. Rúbricas. Evaluaciones por unidad.
                Trabajos integradores.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t border-[#f59e0b]/30" data-id="element-196">
                <span className="text-gray-400 text-[9px] md:text-[10px] line-through font-bold" data-id="element-197">
                  Valor $8.000
                </span>
                <span className="bg-[#eab308] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest shadow-[0_0_8px_rgba(234,179,8,0.5)]" data-id="element-198">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          <div className="max-w-xs mx-auto bg-[#0f1a35]/90 backdrop-blur-sm border-2 border-[#eab308]/50 rounded-xl p-3 md:p-4 text-center shadow-[0_0_20px_rgba(234,179,8,0.15)]" data-id="element-199">
            <p className="text-gray-300 text-[10px] md:text-xs font-bold uppercase tracking-widest mb-1" data-id="element-200">
              Valor total de los 3 bonus:
            </p>
            <p className="text-white text-lg md:text-xl font-black line-through decoration-red-500 decoration-4 mb-1 md:mb-1.5 drop-shadow-sm" data-id="element-201">
              $25.000
            </p>
            <p className="text-gray-300 text-[10px] md:text-xs font-bold uppercase tracking-widest mb-1" data-id="element-202">
              Hoy te los llevás por:
            </p>
            <p className="text-[#eab308] text-3xl md:text-4xl font-black mb-1 md:mb-1.5 drop-shadow-[0_0_10px_rgba(234,179,8,0.4)]" data-id="element-203">
              $0
            </p>
            <p className="text-[#eab308] font-black text-[9px] md:text-[10px] uppercase tracking-widest" data-id="element-204">
              ✨ Incluidos GRATIS con tu compra ✨
            </p>
          </div>
        </div>
      </section>

      {/* URGENCY */}
      <section className="py-4 md:py-6 px-4" style={{
      background: 'linear-gradient(180deg, #1a0f30 0%, #0d1b3a 100%)'
    }} data-id="element-205">
        <div className="max-w-2xl mx-auto text-center" data-id="element-206">
          <h2 className="text-lg md:text-2xl font-black text-[#eab308] mb-3 md:mb-4 uppercase tracking-wider drop-shadow-[0_0_8px_rgba(234,179,8,0.3)]" data-id="element-207">
            El precio de lanzamiento termina en
          </h2>

          <div className="flex items-center justify-center gap-1.5 md:gap-3 mb-3 md:mb-4" data-id="element-208">
            <div className="flex flex-col items-center" data-id="element-209">
              <div className="bg-red-700 border-2 border-red-400 rounded-lg w-10 h-10 md:w-14 md:h-14 flex items-center justify-center shadow-[0_0_20px_rgba(220,38,38,0.5)]" data-id="element-210">
                <span className="text-white text-xl md:text-2xl font-black drop-shadow-md" data-id="element-211">
                  {String(urgencyTime.hours).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-300 text-[8px] md:text-[9px] font-black uppercase tracking-widest mt-1" data-id="element-212">
                Horas
              </span>
            </div>
            <span className="text-red-500 text-xl md:text-2xl font-black -mt-4 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-213">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-214">
              <div className="bg-red-700 border-2 border-red-400 rounded-lg w-10 h-10 md:w-14 md:h-14 flex items-center justify-center shadow-[0_0_20px_rgba(220,38,38,0.5)]" data-id="element-215">
                <span className="text-white text-xl md:text-2xl font-black drop-shadow-md" data-id="element-216">
                  {String(urgencyTime.minutes).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-300 text-[8px] md:text-[9px] font-black uppercase tracking-widest mt-1" data-id="element-217">
                Minutos
              </span>
            </div>
            <span className="text-red-500 text-xl md:text-2xl font-black -mt-4 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-218">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-219">
              <div className="bg-red-700 border-2 border-red-400 rounded-lg w-10 h-10 md:w-14 md:h-14 flex items-center justify-center shadow-[0_0_20px_rgba(220,38,38,0.5)]" data-id="element-220">
                <span className="text-white text-xl md:text-2xl font-black drop-shadow-md" data-id="element-221">
                  {String(urgencyTime.seconds).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-300 text-[8px] md:text-[9px] font-black uppercase tracking-widest mt-1" data-id="element-222">
                Segundos
              </span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-1 md:gap-1.5 mb-3 md:mb-4" data-id="element-223">
            <span className="flex items-center gap-1 bg-[#0f1a35]/80 backdrop-blur-sm border border-[#eab308]/40 shadow-[0_0_10px_rgba(234,179,8,0.1)] text-gray-200 text-[9px] md:text-[10px] font-bold px-2 py-1 rounded-md uppercase tracking-wider" data-id="element-224">
              🔥 Últimas unidades
            </span>
            <span className="flex items-center gap-1 bg-[#0f1a35]/80 backdrop-blur-sm border border-[#eab308]/40 shadow-[0_0_10px_rgba(234,179,8,0.1)] text-gray-200 text-[9px] md:text-[10px] font-bold px-2 py-1 rounded-md uppercase tracking-wider" data-id="element-225">
              📢 Oferta Lanzamiento
            </span>
            <span className="flex items-center gap-1 bg-[#0f1a35]/80 backdrop-blur-sm border border-[#eab308]/40 shadow-[0_0_10px_rgba(234,179,8,0.1)] text-gray-200 text-[9px] md:text-[10px] font-bold px-2 py-1 rounded-md uppercase tracking-wider" data-id="element-226">
              📈 Precio sube al terminar
            </span>
          </div>

          <div className="max-w-sm mx-auto mb-2 md:mb-3" data-id="element-227">
            <div className="relative w-full h-2.5 bg-[#0a1128] rounded-full overflow-hidden border border-[#eab308]/30 shadow-[inset_0_0_5px_rgba(0,0,0,0.5)]" data-id="element-228">
              <div className="h-full rounded-full shadow-[0_0_10px_rgba(239,68,68,0.8)]" style={{
              width: '72%',
              background: 'linear-gradient(90deg, #f97316 0%, #ef4444 60%, #dc2626 100%)'
            }} data-id="element-229" />
            </div>
            <p className="text-[#eab308] text-[9px] font-black mt-1.5 uppercase tracking-widest drop-shadow-sm" data-id="element-230">
              72 % de cupos ocupados
            </p>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="py-4 md:py-6 px-4" style={{
      background: 'linear-gradient(180deg, #0c1a3a 0%, #1a1040 50%, #0c1a3a 100%)'
    }} data-id="element-231">
        <div className="max-w-4xl mx-auto" data-id="element-232">
          <h2 className="text-xl md:text-3xl font-black text-white text-center mb-3 md:mb-5 uppercase drop-shadow-md" data-id="element-233">
            Elegí tu{' '}
            <span className="underline decoration-[#eab308] decoration-4 underline-offset-4 drop-shadow-[0_0_10px_rgba(234,179,8,0.3)]" data-id="element-234">
              Pack Completo
            </span>
          </h2>

          <PricingGrid selectedPack={selectedPack} setSelectedPack={setSelectedPack} packLinks={packLinks} data-id="element-235" />

          {/* Features Box */}
          <div className="max-w-xl mx-auto bg-[#0f1a35]/90 backdrop-blur-sm border-2 border-[#eab308]/60 shadow-[0_0_20px_rgba(234,179,8,0.2)] rounded-xl p-3 md:p-4" data-id="element-236">
            <h3 className="text-white font-black text-xs md:text-sm mb-2 md:mb-3 flex items-center gap-1.5 uppercase tracking-wider drop-shadow-sm" data-id="element-237">
              👑 PACK COMPLETO INCLUYE:
            </h3>
            <ul className="space-y-1 md:space-y-1.5" data-id="element-238">
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-239">
                <CheckIcon className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-240" />
                6 tomos de contenidos sobre medios y redes para todo el año
              </li>
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-241">
                <CheckIcon className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-242" />
                BONUS: Planificación Anual de Observatorio de Medios
              </li>
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-243">
                <CheckIcon className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-244" />
                BONUS: 100 Actividades sobre Medios y Redes
              </li>
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-245">
                <CheckIcon className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-246" />
                BONUS: Sistema PRO de Evaluación en Medios
              </li>
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-247">
                <CheckIcon className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-248" />
                Entrega inmediata por Drive (PDF)
              </li>
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-249">
                <CheckIcon className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-250" />
                Acceso de por vida — sin vencimiento
              </li>
              <li className="flex items-start gap-1.5 text-gray-200 text-[10px] md:text-xs font-medium" data-id="element-251">
                <CheckIcon className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-252" />
                Garantía de satisfacción de 7 días
              </li>
            </ul>
          </div>

          <p className="text-center text-gray-400 text-[9px] md:text-[10px] mt-2 md:mt-3 flex items-center justify-center gap-1 font-bold uppercase tracking-widest" data-id="element-253">
            <CreditCardIcon className="w-3 h-3 text-[#eab308]" data-id="element-254" />
            Transferencia · Mercado Pago · Tarjeta
          </p>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-3 md:py-5 px-4" style={{
      background: 'linear-gradient(180deg, #0c1a3a 0%, #0f1f3d 100%)'
    }} data-id="element-255">
        <div className="max-w-2xl mx-auto text-center" data-id="element-256">
          <h2 className="text-base md:text-lg font-black text-white mb-2 md:mb-3 uppercase drop-shadow-md" data-id="element-257">
            🔽 ¿Cómo recibís el{' '}
            <span className="underline decoration-[#eab308] decoration-4 underline-offset-2 drop-shadow-[0_0_8px_rgba(234,179,8,0.3)]" data-id="element-258">
              material
            </span>
            ?
          </h2>

          <div className="grid grid-cols-3 gap-1.5 md:gap-3" data-id="element-259">
            <div className="relative" data-id="element-260">
              <div className="w-6 h-6 md:w-8 md:h-8 bg-[#eab308] rounded-full flex items-center justify-center text-xs md:text-sm font-black text-black mx-auto mb-1 shadow-[0_0_15px_rgba(234,179,8,0.4)] border border-yellow-200" data-id="element-261">
                1
              </div>
              <h3 className="text-[9px] md:text-[11px] font-black text-white mb-0.5 uppercase drop-shadow-sm" data-id="element-262">
                Comprás
              </h3>
              <p className="text-gray-300 text-[8px] md:text-[10px] font-medium leading-tight" data-id="element-263">
                Ingresás tu correo.
              </p>
            </div>
            <div className="relative" data-id="element-264">
              <div className="w-6 h-6 md:w-8 md:h-8 bg-[#eab308] rounded-full flex items-center justify-center text-xs md:text-sm font-black text-black mx-auto mb-1 shadow-[0_0_15px_rgba(234,179,8,0.4)] border border-yellow-200" data-id="element-265">
                2
              </div>
              <h3 className="text-[9px] md:text-[11px] font-black text-white mb-0.5 uppercase drop-shadow-sm" data-id="element-266">
                Pagás
              </h3>
              <p className="text-gray-300 text-[8px] md:text-[10px] font-medium leading-tight" data-id="element-267">
                Pago seguro.
              </p>
            </div>
            <div className="relative" data-id="element-268">
              <div className="w-6 h-6 md:w-8 md:h-8 bg-[#eab308] rounded-full flex items-center justify-center text-xs md:text-sm font-black text-black mx-auto mb-1 shadow-[0_0_15px_rgba(234,179,8,0.4)] border border-yellow-200" data-id="element-269">
                3
              </div>
              <h3 className="text-[9px] md:text-[11px] font-black text-white mb-0.5 uppercase drop-shadow-sm" data-id="element-270">
                Descargás
              </h3>
              <p className="text-gray-300 text-[8px] md:text-[10px] font-medium leading-tight" data-id="element-271">
                Recibís el link.
              </p>
            </div>
          </div>

          <div className="mt-2 bg-[#0f1a35]/80 backdrop-blur-sm border-2 border-[#eab308]/40 shadow-[0_0_10px_rgba(234,179,8,0.15)] rounded-lg p-1.5 inline-block" data-id="element-272">
            <p className="text-gray-200 flex items-center justify-center gap-1 font-bold text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-273">
              <AlertTriangleIcon className="w-3 h-3 text-[#eab308] drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-274" />
              Si no lo ves en tu bandeja, revisá spam.
            </p>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-3 md:py-5 px-4 border-t-2 border-[#eab308]/20" style={{
      background: 'linear-gradient(180deg, #0f1f3d 0%, #0c1a3a 100%)'
    }} data-id="element-275">
        <div className="max-w-2xl mx-auto text-center" data-id="element-276">
          <ShieldCheckIcon className="w-10 h-10 md:w-12 md:h-12 text-[#eab308] mx-auto mb-1.5 md:mb-2 drop-shadow-[0_0_15px_rgba(234,179,8,0.6)]" data-id="element-277" />
          <h2 className="text-lg md:text-xl font-black text-white mb-1 uppercase drop-shadow-md" data-id="element-278">
            Garantía de{' '}
            <span className="underline decoration-[#eab308] decoration-4 underline-offset-2 drop-shadow-[0_0_8px_rgba(234,179,8,0.3)]" data-id="element-279">
              Satisfacción Total
            </span>
          </h2>
          <p className="text-xs md:text-sm text-gray-300 font-medium" data-id="element-280">
            Probalo 7 días. Si no cumple tus expectativas, te devolvemos el
            100%. Sin preguntas.
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-4 md:py-6 px-4 border-t-2 border-[#eab308]/20" style={{
      background: 'linear-gradient(180deg, #0f1f3d 0%, #0c2340 100%)'
    }} data-id="element-281">
        <div className="max-w-4xl mx-auto" data-id="element-282">
          <h2 className="text-xl md:text-3xl font-black text-center text-white mb-3 md:mb-5 uppercase drop-shadow-md" data-id="element-283">
            <span className="text-[#eab308] drop-shadow-[0_0_10px_rgba(234,179,8,0.4)]" data-id="element-284">
              Testimonios
            </span>{' '}
            de Docentes
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-3" data-id="element-285">
            <div className="bg-[#0f1a35]/80 backdrop-blur-sm p-3 rounded-xl border-2 border-[#eab308]/30 shadow-[0_0_10px_rgba(234,179,8,0.1)] hover:border-[#eab308]/60 hover:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all" data-id="element-286">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 drop-shadow-[0_0_3px_rgba(250,204,21,0.5)]" data-id="element-287">
                <StarIcon className="w-3 h-3 fill-current" data-id="element-288" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-289" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-290" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-291" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-292" />
              </div>
              <p className="text-gray-200 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-293">
                "Arranqué el año sin nada armado para Observatorio de Medios y
                con este pack en una tarde ya tenía todo planificado. Las
                actividades con redes sociales y noticias reales son increíbles
                y los chicos se enganchan al toque. Me salvó literalmente el
                cuatrimestre."
              </p>
              <div className="font-black text-white text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-294">
                Soledad M., 34 años –{' '}
                <span className="text-[#eab308] font-bold" data-id="element-295">
                  La Plata, Buenos Aires
                </span>
              </div>
            </div>

            <div className="bg-[#0f1a35]/80 backdrop-blur-sm p-3 rounded-xl border-2 border-[#eab308]/30 shadow-[0_0_10px_rgba(234,179,8,0.1)] hover:border-[#eab308]/60 hover:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all" data-id="element-296">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 drop-shadow-[0_0_3px_rgba(250,204,21,0.5)]" data-id="element-297">
                <StarIcon className="w-3 h-3 fill-current" data-id="element-298" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-299" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-300" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-301" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-302" />
              </div>
              <p className="text-gray-200 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-303">
                "Doy Observatorio de Medios en dos escuelas y siempre me costaba
                encontrar material actualizado. Este pack está pensado para
                secundaria de verdad. Los análisis de noticias y las actividades
                con Instagram y TikTok son excelentes. Las rúbricas me facilitan
                la corrección."
              </p>
              <div className="font-black text-white text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-304">
                Ricardo G., 41 años –{' '}
                <span className="text-[#eab308] font-bold" data-id="element-305">
                  Rosario, Santa Fe
                </span>
              </div>
            </div>

            <div className="bg-[#0f1a35]/80 backdrop-blur-sm p-3 rounded-xl border-2 border-[#eab308]/30 shadow-[0_0_10px_rgba(234,179,8,0.1)] hover:border-[#eab308]/60 hover:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all" data-id="element-306">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 drop-shadow-[0_0_3px_rgba(250,204,21,0.5)]" data-id="element-307">
                <StarIcon className="w-3 h-3 fill-current" data-id="element-308" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-309" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-310" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-311" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-312" />
              </div>
              <p className="text-gray-200 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-313">
                "Lo que más me gustó es el Tomo 6 del Proyecto Integrador. Mis
                alumnos armaron su propio observatorio de medios y fue la mejor
                experiencia del año. Los directivos quedaron impresionados con
                las presentaciones."
              </p>
              <div className="font-black text-white text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-314">
                Claudia V., 39 años –{' '}
                <span className="text-[#eab308] font-bold" data-id="element-315">
                  Córdoba Capital
                </span>
              </div>
            </div>

            <div className="bg-[#0f1a35]/80 backdrop-blur-sm p-3 rounded-xl border-2 border-[#eab308]/30 shadow-[0_0_10px_rgba(234,179,8,0.1)] hover:border-[#eab308]/60 hover:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all" data-id="element-316">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 drop-shadow-[0_0_3px_rgba(250,204,21,0.5)]" data-id="element-317">
                <StarIcon className="w-3 h-3 fill-current" data-id="element-318" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-319" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-320" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-321" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-322" />
              </div>
              <p className="text-gray-200 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-323">
                "Soy docente hace 15 años y nunca encontré un material tan
                completo para trabajar medios y comunicación. Antes perdía fines
                de semana enteros armando clases. Ahora abro el PDF, imprimo y
                listo. La planificación anual que viene de bonus es un golazo."
              </p>
              <div className="font-black text-white text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-324">
                Alejandro D., 47 años –{' '}
                <span className="text-[#eab308] font-bold" data-id="element-325">
                  San Miguel de Tucumán
                </span>
              </div>
            </div>

            <div className="bg-[#0f1a35]/80 backdrop-blur-sm p-3 rounded-xl border-2 border-[#eab308]/30 shadow-[0_0_10px_rgba(234,179,8,0.1)] hover:border-[#eab308]/60 hover:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all" data-id="element-326">
              <div className="flex gap-0.5 text-yellow-400 mb-1.5 drop-shadow-[0_0_3px_rgba(250,204,21,0.5)]" data-id="element-327">
                <StarIcon className="w-3 h-3 fill-current" data-id="element-328" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-329" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-330" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-331" />
                <StarIcon className="w-3 h-3 fill-current" data-id="element-332" />
              </div>
              <p className="text-gray-200 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-333">
                "Mis alumnos siempre estaban en el celular durante clase. Con
                las actividades de análisis de redes sociales y fake news ahora
                se enganchan solos. El material de cultura digital les fascina
                porque lo conectan con su vida diaria."
              </p>
              <div className="font-black text-white text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-334">
                Natalia P., 36 años –{' '}
                <span className="text-[#eab308] font-bold" data-id="element-335">Mendoza</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-4 md:py-6 px-4" style={{
      background: 'linear-gradient(180deg, #0c2340 0%, #0d1b3a 100%)'
    }} data-id="element-336">
        <div className="max-w-2xl mx-auto" data-id="element-337">
          <h2 className="text-xl md:text-2xl font-black text-center text-white mb-3 md:mb-4 uppercase drop-shadow-md" data-id="element-338">
            Preguntas{' '}
            <span className="underline decoration-[#eab308] decoration-4 underline-offset-2 drop-shadow-[0_0_8px_rgba(234,179,8,0.3)]" data-id="element-339">
              Frecuentes
            </span>
          </h2>

          <div className="space-y-1.5 md:space-y-2" data-id="element-340">
            <details className="group bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#d97706]/30 open:border-[#eab308]/60 open:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all duration-200" data-id="element-341">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3.5 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-342">
                ¿En qué formato recibo el material?
                <ChevronDownIcon className="w-4 h-4 text-[#eab308] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-343" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3.5 md:pb-3.5 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-[#eab308]/20 pt-2.5" data-id="element-344">
                Todo el material viene en formato PDF, listo para descargar,
                imprimir o usar de forma digital en cualquier dispositivo.
              </div>
            </details>

            <details className="group bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#d97706]/30 open:border-[#eab308]/60 open:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all duration-200" data-id="element-345">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3.5 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-346">
                ¿Cuánto tarda en llegar después de pagar?
                <ChevronDownIcon className="w-4 h-4 text-[#eab308] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-347" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3.5 md:pb-3.5 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-[#eab308]/20 pt-2.5" data-id="element-348">
                El acceso es inmediato. Apenas completás el pago, recibís el
                link de descarga en tu correo electrónico. Si no lo ves en la
                bandeja de entrada, revisá la carpeta de spam.
              </div>
            </details>

            <details className="group bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#d97706]/30 open:border-[#eab308]/60 open:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all duration-200" data-id="element-349">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3.5 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-350">
                ¿Puedo imprimir el material y usarlo en varias divisiones?
                <ChevronDownIcon className="w-4 h-4 text-[#eab308] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-351" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3.5 md:pb-3.5 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-[#eab308]/20 pt-2.5" data-id="element-352">
                Sí, podés imprimirlo todas las veces que necesites y usarlo en
                todas las divisiones y cursos donde des la materia. El acceso es
                de por vida.
              </div>
            </details>

            <details className="group bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#d97706]/30 open:border-[#eab308]/60 open:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all duration-200" data-id="element-353">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3.5 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-354">
                ¿Está alineado a los NAP 2026?
                <ChevronDownIcon className="w-4 h-4 text-[#eab308] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-355" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3.5 md:pb-3.5 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-[#eab308]/20 pt-2.5" data-id="element-356">
                Sí, el pack está 100% alineado a los Núcleos de Aprendizajes
                Prioritarios 2026 para Observatorio de Medios. Podés presentar
                la planificación ante directivos con total confianza.
              </div>
            </details>

            <details className="group bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#d97706]/30 open:border-[#eab308]/60 open:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all duration-200" data-id="element-357">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3.5 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-358">
                ¿Qué pasa si no me sirve o no es lo que esperaba?
                <ChevronDownIcon className="w-4 h-4 text-[#eab308] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-359" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3.5 md:pb-3.5 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-[#eab308]/20 pt-2.5" data-id="element-360">
                Tenés 7 días de garantía total. Si el material no cumple tus
                expectativas por cualquier motivo, te devolvemos el 100% de tu
                dinero sin hacerte ninguna pregunta.
              </div>
            </details>

            <details className="group bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#d97706]/30 open:border-[#eab308]/60 open:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all duration-200" data-id="element-361">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3.5 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-362">
                ¿Para qué año de secundaria sirve?
                <ChevronDownIcon className="w-4 h-4 text-[#eab308] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-363" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3.5 md:pb-3.5 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-[#eab308]/20 pt-2.5" data-id="element-364">
                Sirve para todos los años donde se dicte Observatorio de Medios
                o materias afines. El contenido es adaptable y cubre desde
                análisis de noticias hasta cultura digital.
              </div>
            </details>

            <details className="group bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#d97706]/30 open:border-[#eab308]/60 open:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all duration-200" data-id="element-365">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3.5 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-366">
                No tengo tarjeta de crédito, ¿puedo pagar de otra forma?
                <ChevronDownIcon className="w-4 h-4 text-[#eab308] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-367" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3.5 md:pb-3.5 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-[#eab308]/20 pt-2.5" data-id="element-368">
                Sí, aceptamos múltiples medios de pago: transferencia bancaria,
                Mercado Pago, tarjeta de débito y tarjeta de crédito. Elegí el
                que te resulte más cómodo.
              </div>
            </details>

            <details className="group bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#d97706]/30 open:border-[#eab308]/60 open:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all duration-200" data-id="element-369">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3.5 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-370">
                ¿Incluye planificación anual lista para presentar?
                <ChevronDownIcon className="w-4 h-4 text-[#eab308] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-371" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3.5 md:pb-3.5 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-[#eab308]/20 pt-2.5" data-id="element-372">
                Sí, como bonus incluimos una Planificación Anual completa de
                Observatorio de Medios con objetivos, contenidos por unidad,
                actividades sugeridas y criterios de evaluación. Lista para
                presentar ante directivos sin modificar nada.
              </div>
            </details>

            <details className="group bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#d97706]/30 open:border-[#eab308]/60 open:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all duration-200" data-id="element-373">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3.5 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-374">
                ¿Sirve si ya empecé el año y necesito material urgente?
                <ChevronDownIcon className="w-4 h-4 text-[#eab308] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-375" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3.5 md:pb-3.5 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-[#eab308]/20 pt-2.5" data-id="element-376">
                ¡Sí! Muchos docentes lo compran a mitad de año. El material está
                organizado por tomos temáticos, así que podés empezar por el
                tema que necesites sin seguir un orden fijo. Lo descargás al
                instante y lo usás en tu próxima clase.
              </div>
            </details>

            <details className="group bg-[#0f1a35]/80 backdrop-blur-sm rounded-lg border-2 border-[#d97706]/30 open:border-[#eab308]/60 open:shadow-[0_0_15px_rgba(234,179,8,0.2)] transition-all duration-200" data-id="element-377">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3.5 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-378">
                ¿Qué diferencia hay entre el pack de $19.990 y el de $27.990?
                <ChevronDownIcon className="w-4 h-4 text-[#eab308] group-open:rotate-180 transition-transform drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-379" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3.5 md:pb-3.5 text-[10px] md:text-xs text-gray-300 font-medium leading-snug border-t border-[#eab308]/20 pt-2.5" data-id="element-380">
                El pack de $19.990 incluye los 6 tomos de Observatorio de Medios
                con todos los bonus. El pack de $27.990 incluye todo eso más el
                Sistema Avanzado de Análisis Mediático, ideal si querés que tus
                alumnos trabajen análisis profundo de medios y cultura digital.
              </div>
            </details>
          </div>
        </div>
      </section>

      {/* BOTTOM PRICING (Replicated) */}
      <section className="py-4 md:py-6 px-4" style={{
      background: 'linear-gradient(180deg, #1a1040 0%, #0c1a3a 100%)'
    }} data-id="element-381">
        <div className="max-w-4xl mx-auto" data-id="element-382">
          <h2 className="text-xl md:text-3xl font-black text-white text-center mb-3 md:mb-5 uppercase drop-shadow-md" data-id="element-383">
            Elegí tu{' '}
            <span className="underline decoration-[#eab308] decoration-4 underline-offset-4 drop-shadow-[0_0_10px_rgba(234,179,8,0.3)]" data-id="element-384">
              Pack Completo
            </span>
          </h2>

          <PricingGrid selectedPack={selectedPack} setSelectedPack={setSelectedPack} packLinks={packLinks} data-id="element-385" />
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-4 md:py-6 px-4 text-center" style={{
      background: 'linear-gradient(180deg, #0d1b3a 0%, #1a1040 100%)'
    }} data-id="element-386">
        <div className="max-w-3xl mx-auto" data-id="element-387">
          <h2 className="text-xl md:text-3xl font-black text-white mb-1 md:mb-2 uppercase drop-shadow-md" data-id="element-388">
            ¿Listo/a para{' '}
            <span className="underline decoration-[#eab308] decoration-4 underline-offset-4 drop-shadow-[0_0_10px_rgba(234,179,8,0.3)]" data-id="element-389">
              transformar tu año
            </span>{' '}
            en Observatorio de Medios?
          </h2>
          <p className="text-xs md:text-sm text-gray-300 mb-2 md:mb-4 font-bold uppercase tracking-wider" data-id="element-390">
            Sumate a los más de 3.000 docentes que ya dejaron de improvisar.
          </p>

          <p className="text-[#eab308] font-black uppercase tracking-widest text-[9px] md:text-[10px] drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-391">
            📈 PACK COMPLETO OBSERVATORIO DE MEDIOS Y REDES
          </p>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="bg-[#0a1128] py-2 md:py-3 px-4 text-center border-t-2 border-[#eab308]/20" data-id="element-392">
        <p className="text-gray-400 text-[10px] md:text-xs font-bold uppercase tracking-wider" data-id="element-393">
          ¿Tenés dudas? Escribinos a{' '}
          <a href="mailto:kitonline27@gmail.com" className="text-[#eab308] font-black hover:underline drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]" data-id="element-394">
            kitonline27@gmail.com
          </a>
        </p>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#0a1128] text-gray-500 py-3 md:py-4 px-4 text-center text-[9px] md:text-[10px] border-t border-[#1e293b] font-bold uppercase tracking-widest" data-id="element-395">
        <p className="mb-1.5 md:mb-2" data-id="element-396">
          © 2026 Pack Completo Observatorio de Medios y Redes™
        </p>
        <div className="flex justify-center gap-3 md:gap-4" data-id="element-397">
          <span className="hover:text-gray-300 cursor-pointer transition-colors" data-id="element-398">
            Términos
          </span>
          <span className="hover:text-gray-300 cursor-pointer transition-colors" data-id="element-399">
            Privacidad
          </span>
          <span className="hover:text-gray-300 cursor-pointer transition-colors" data-id="element-400">
            Soporte
          </span>
        </div>
      </footer>
    </div>;
}